var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.height)?_c('Bar',{staticClass:"pt-3",attrs:{"data":_vm.chartData,"height":_vm.height}}):_c('Bar',{staticClass:"pt-3",attrs:{"data":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }